import React from 'react';
import LogoFull from './assets/logo-full-gradient.png';
import './App.css';
import { cssVariables } from './Colors';

function App() {
  return (
    <>
      <style>{cssVariables}</style>
      <div className="App">
        <header className="App-header">
          <img src={LogoFull} className="App-logo" alt="logo" />
        </header>
      </div>
    </>
  );
}

export default App;
